import React from "react";
import Header from "../components/Header/Header";
// import Layout from "../components/layout/Layout";
import Layout from "../components/Layout/Layout";
import SignUp from "../components/User/SignUp/SignUp";
import styled, { css } from "styled-components";

const SignIn = () => {
  return <SignUp />;
};

export default SignIn;
